<script setup lang="ts">
import { i18n } from '@apps/main/modules/localization/localizationSetup';
import type {
  AppMultiSelectOption,
  AppMultiSelectSelectedPlaceholder,
} from 'libs/ui/src/lib/components/selects/models/multi.model';

import { AppMultiSelect } from '@libs/ui';

import { HotelFilter } from '../model/hotelFilters';
import type { NeighborhoodPolygonsFilterUpdate } from '../model/hotelFilters';

const { t } = i18n.global;
interface HotelNeighborhoodFiltersProps {
  options: AppMultiSelectOption<string>[];
  useTeleport?: boolean;
  selectedPlaceholderFormat?: AppMultiSelectSelectedPlaceholder;
  shouldShowClearButton?: boolean;
  isWrapperScrolling?: boolean;
}
const props = defineProps<HotelNeighborhoodFiltersProps>();

interface HotelNeighborhoodFiltersEmits {
  (
    eventName: 'neighborhood-option-selected',
    value: NeighborhoodPolygonsFilterUpdate
  ): void;
  (eventName: 'clear-selection'): void;
}
const emit = defineEmits<HotelNeighborhoodFiltersEmits>();

function onSelectOption(selectedOption: AppMultiSelectOption<string>): void {
  emit('neighborhood-option-selected', {
    type: HotelFilter.NeighborhoodPolygons,
    value: selectedOption.id,
  });
}
</script>

<template>
  <AppMultiSelect
    type="modern"
    :options="props.options"
    :use-teleport="props.useTeleport"
    :placeholder="t('filter.neighbourhood')"
    :placeholder-selected="t('filter.neighbourhood')"
    :selected-placeholder-format="props.selectedPlaceholderFormat"
    should-show-clear-button
    :is-wrapper-scrolling="isWrapperScrolling"
    :dynamic-height="false"
    @clear-selection="emit('clear-selection')"
    @select-single="onSelectOption"
  />
</template>
